/**
 * Auth storage keys — single source of truth.
 *
 * The access/refresh tokens are persisted in localStorage under these keys by
 * the auth store (`stores/auth.ts`). Every module that reads the token MUST
 * import these constants rather than hardcoding the string literal, so the key
 * cannot drift (a divergent literal silently sends unauthenticated requests).
 */
export const AUTH_TOKEN_KEY = "auth_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
